import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// redux importing
import { ONCHANGE_INFO_USER, RESULT_SUBMIT } from "../../redux/reducer/_index";

// mui icon importing
import PersonOutlineTwoToneIcon from '@mui/icons-material/PersonOutlineTwoTone';
import CalendarMonthTwoToneIcon from '@mui/icons-material/CalendarMonthTwoTone';
import PhoneIphoneTwoToneIcon from '@mui/icons-material/PhoneIphoneTwoTone';
import LocalPostOfficeTwoToneIcon from '@mui/icons-material/LocalPostOfficeTwoTone';
import WorkTwoToneIcon from '@mui/icons-material/WorkTwoTone';

const FormContent = () => {

  // TODO: navigate
  const navigate = useNavigate();

  // TODO: redux
  const data = useSelector((state: any) => state.appReducer.data);
  const dispatch = useDispatch();

  // TODO: onClick
  const _onClickSubmit = () => {

    if (
      data.user.dob === "invalid" || data.user.dob === "" ||
      data.user.phoneNumber === "invalid" || data.user.phoneNumber === "" ||
      data.user.email === "invalid" || data.user.email === ""
    ) {
      return
    } else {
      dispatch(RESULT_SUBMIT())
      navigate("/result", { replace: true });
    }
  }

  return (
    <div className="flex space-y-4 flex-col p-5 w-full h-max">
      {/* fullname */}
      <div className="flex flex-col w-full h-max">
        {/* title */}
        <div className="flex space-x-1 items-center w-full h-max">
          <PersonOutlineTwoToneIcon fontSize="small" />
          <p>Họ và tên</p>
        </div>

        {/* input */}
        <input
          className="w-full h-7 pl-1 pr-1 bg-gray-200 rounded-sm border-2 border-slate-200"
          readOnly
          value={sessionStorage.getItem("fullname")?.toString()}
        />
      </div>

      {/* dob */}
      <div className="flex flex-col w-full h-max">
        {/* title */}
        <div className="flex space-x-1 items-center w-full h-max">
          <CalendarMonthTwoToneIcon fontSize="small" />
          <p>Ngày tháng năm sinh</p>
        </div>

        {data.user.dob === "invalid" || data.user.dob === "" ? <p className="text-xs text-rose-600">Ngày tháng năm sinh không hợp lệ hoặc còn trống.</p> : ""}

        {/* input */}
        <input
          className="w-full h-7 pl-1 pr-1 bg-slate-50 border-2 border-slate-200 rounded-sm"
          type="date"
          onChange={(e: any) => {
            e.preventDefault();

            var datePart = e.target.value.match(/\d+/g),
              year = datePart[0].substring(0), // get only two digits
              month = datePart[1], day = datePart[2];

            const result = day + '/' + month + '/' + year

            dispatch(ONCHANGE_INFO_USER({ type: "dob", value: result }))
          }}
        />
      </div>

      {/* phone number */}
      <div className="flex flex-col w-full h-max">
        {/* title */}
        <div className="flex space-x-1 items-center w-full h-max">
          <PhoneIphoneTwoToneIcon fontSize="small" />
          <p>Số điện thoại</p>
        </div>

        {data.user.phoneNumber === "invalid" || data.user.phoneNumber === "" ? <p className="text-xs text-rose-600">Số điện thoại không hợp lệ hoặc còn trống.</p> : ""}

        {/* input */}
        <input
          className="w-full h-7 pl-1 pr-1 bg-slate-50 border-2 border-slate-200 rounded-sm"
          type="number"
          onChange={(e: any) => {
            e.preventDefault();
            dispatch(ONCHANGE_INFO_USER({ type: "phoneNumber", value: e.target.value }))
          }}
        />
      </div>

      {/* email */}
      <div className="flex flex-col w-full h-max">
        {/* title */}
        <div className="flex space-x-1 items-center w-full h-max">
          <LocalPostOfficeTwoToneIcon fontSize="small" />
          <p>Địa chỉ Email</p>
        </div>

        {data.user.email === "invalid" || data.user.email === "" ? <p className="text-xs text-rose-600">Địa chỉ email không hợp lệ hoặc còn trống.</p> : ""}

        {/* input */}
        <input
          className="w-full h-7 pl-1 pr-1 bg-slate-50 border-2 border-slate-200 rounded-sm"
          onChange={(e: any) => {
            e.preventDefault();
            dispatch(ONCHANGE_INFO_USER({ type: "email", value: e.target.value }))
          }}
        />
      </div>

      {/* job */}
      <div className="flex flex-col w-full h-max">
        {/* title */}
        <div className="flex space-x-1 items-center w-full h-max">
          <WorkTwoToneIcon fontSize="small" />
          <p>Nghề nghiệp</p>
        </div>

        {/* input */}
        <select
          className="
            w-full h-7 pl-1 pr-1 bg-slate-50 border-2 border-slate-200 rounded-sm
          "
          onChange={(e: any) => {
            e.preventDefault();
            dispatch(ONCHANGE_INFO_USER({ type: "job", value: e.target.value }))
          }}
        >
          <option value="Học sinh">Học sinh</option>
          <option value="Sinh Viên">Sinh viên</option>
          <option value="Đã đi làm">Đã đi làm</option>
        </select>
      </div>

      {/* submit button */}
      <div className="flex justify-center mt-9 items-center w-full h-max">
        <button className="w-[6rem] h-[2rem] bg-sky-600 hover:bg-sky-500 text-white font-medium rounded-md"
          onClick={_onClickSubmit}
        >
          Xác nhận
        </button>
      </div>
    </div>
  )
}

export default FormContent;
